export default __webpack_public_path__ + "static/media/portadavideoplanificacion2.5e6ec289.png";